import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiUpload } from 'react-icons/fi';
import { FaWallet } from 'react-icons/fa';

const PaymentMethodScreen = () => {
  const navigate = useNavigate();

  const paymentMethods = [
    {
      id: 'receipt',
      title: 'وصل الإيداع البنكي',
      description: 'قم بتحويل المبلغ وارفع صورة الوصل',
      icon: FiUpload,
      bgColor: 'bg-blue-50 dark:bg-blue-950/40',
      iconColor: 'text-blue-600 dark:text-blue-300',
      borderColor: 'border-blue-200 dark:border-blue-800',
      hoverBg: 'hover:bg-blue-100 dark:hover:bg-blue-900/50',
      route: '/receipt-upload'
    },
    {
      id: 'wallet',
      title: 'الدفع بواسطة المحفظة',
      description: 'ادفع مباشرة من رصيد محفظتك الإلكترونية',
      icon: FaWallet,
      bgColor: 'bg-amber-50 dark:bg-amber-950/40',
      iconColor: 'text-amber-600 dark:text-amber-300',
      borderColor: 'border-amber-200 dark:border-amber-800',
      hoverBg: 'hover:bg-amber-100 dark:hover:bg-amber-900/50',
      // ✅ نفس مسار صفحة العمولة (CommissionPaymentScreen) الذي يعمل بشكل صحيح
      route: '/card-payment'
    }
  ];

  const handleMethodSelect = (route) => {
    navigate(route);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      {/* Header */}
      <div className="bg-khidma-black text-white px-4 md:px-6 py-5 shadow-md flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="text-white hover:text-gray-300 transition-colors p-2 -ml-2 rounded-full hover:bg-white/10"
        >
          <FiArrowLeft className="text-xl md:text-2xl" />
        </button>
        <h1 className="text-xl md:text-2xl font-bold">اختر طريقة الدفع</h1>
        <div className="w-8 md:w-10"></div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4 md:p-6">
        <div className="w-full max-w-2xl mx-auto space-y-4">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-2">
              كيف تريد الدفع؟
            </h2>
            <p className="text-gray-600 dark:text-gray-300 text-sm md:text-base">
              اختر طريقة الدفع المناسبة لك
            </p>
          </div>

          {paymentMethods.map((method) => (
            <button
              key={method.id}
              onClick={() => handleMethodSelect(method.route)}
              className={`w-full ${method.bgColor} border-2 ${method.borderColor} rounded-2xl p-6 md:p-8 ${method.hoverBg} transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98]`}
            >
              <div className="flex items-center space-x-4 space-x-reverse">
                <div className={`${method.bgColor} rounded-xl p-4 md:p-5 border ${method.borderColor}`}>
                  <method.icon className={`text-3xl md:text-4xl ${method.iconColor}`} />
                </div>
                <div className="flex-1 text-right">
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white mb-1">
                    {method.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 dark:text-gray-300">
                    {method.description}
                  </p>
                </div>
                <FiArrowLeft className="text-gray-400 dark:text-gray-400 text-xl md:text-2xl transform rotate-180" />
              </div>
            </button>
          ))}

          {/* معلومات إضافية */}
          <div className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700 mt-8">
            <h4 className="font-bold text-gray-900 dark:text-white mb-3 text-center">ملاحظات هامة</h4>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-300 text-right">
              <li className="flex items-start space-x-2 space-x-reverse">
                <span className="text-blue-600 dark:text-blue-400 mt-1">•</span>
                <span>يرجى التأكد من صحة المبلغ المحول قبل إتمام العملية</span>
              </li>
              <li className="flex items-start space-x-2 space-x-reverse">
                <span className="text-blue-600 dark:text-blue-400 mt-1">•</span>
                <span>قد تستغرق عملية التحقق من الدفع حتى 24 ساعة</span>
              </li>
              <li className="flex items-start space-x-2 space-x-reverse">
                <span className="text-blue-600 dark:text-blue-400 mt-1">•</span>
                <span>في حالة وجود أي استفسار، تواصل مع فريق الدعم</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodScreen;